export const mainPath = {
  home: { path: `/home`, name: 'Home' },
  searchResults: { path: `/search-results`, name: 'Search results' },
  chat: { path: `/chat`, name: 'Chat' },
};
